import React from "react";

/**
 * FOXID identity / face-match outcome — shown identically in the client member
 * FOXID/Identity view and the admin member modal (one component so they can't
 * drift). Plain-English labels, not the raw status codes.
 *
 *   status ∈ matched | failed | not_performed | skipped   (null → renders nothing)
 */
const META = {
  matched:       { label: "Verified",     bg: "rgba(16,185,129,0.16)",  fg: "#059669" },
  failed:        { label: "Not matched",  bg: "rgba(220,38,38,0.14)",   fg: "#dc2626" },
  not_performed: { label: "Not verified", bg: "rgba(217,119,6,0.16)",   fg: "#b45309" },
  skipped:       { label: "Skipped",      bg: "rgba(100,116,139,0.16)", fg: "#64748b" },
};

export function faceMatchLabel(status) { return META[status]?.label || null; }

/**
 * A plain-English sentence describing what happened, for the verification card.
 *   status, faceMatch verdict object, hasLicence (was a licence captured?)
 */
export function faceMatchSentence(status, faceMatch, hasLicence) {
  const sim = faceMatch && faceMatch.Similarity != null ? ` (${faceMatch.Similarity}% similarity)` : "";
  switch (status) {
    case "matched": return `The selfie matches the licence photo${sim}.`;
    case "failed":  return `The selfie did not match the licence photo${sim}.`;
    case "skipped": return "The member skipped the selfie step.";
    case "not_performed":
      return hasLicence
        ? "Selfie captured, but no face-match result was returned."
        : "Selfie captured — details entered manually, so there was no licence photo to match against.";
    default: return "";
  }
}

export default function FaceMatchBadge({ status, size = "md" }) {
  const m = META[status];
  if (!m) return null;
  return (
    <span
      title="FOXID identity verification"
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: size === "sm" ? "2px 8px" : "3px 10px",
        borderRadius: 999,
        background: m.bg,
        color: m.fg,
        fontSize: size === "sm" ? "0.7rem" : "0.75rem",
        fontWeight: 700,
        whiteSpace: "nowrap",
      }}
    >
      {m.label}
    </span>
  );
}
